import context from "@helpers/context"
import useStatic from "@hooks/useStatic"
import React, { useCallback, useState } from "react"
import styled from "styled-components"

const [SliderContext, useSliderContext] = context<Contexts.Slider>()
const [SliderStateContext, useSliderStateContext] = context<Contexts.Slider.State>()

const SliderProvider: React.FC = ({ children }) => {
    const [state, setState] = useState<Contexts.Slider.State>("hidden")
    const [element, setElement] = useState<React.ReactNode>(null)

    const open = useCallback(() => setState("visible"), [])
    const close = useCallback(() => {
        setState("hiding")

        return new Promise<void>(resolve => {
            setTimeout(() => {
                setState("hidden")
                setElement(null)
                resolve()
            }, 200)
        })
    }, [])

    const value = useStatic({ open, close, setElement })

    return (
        <SliderContext.Provider value={value}>
            <SliderStateContext.Provider value={state}>
                {children}
                <SliderWrapper visible={state !== "hidden"}>
                    {element}
                </SliderWrapper>
            </SliderStateContext.Provider>
        </SliderContext.Provider>
    )
}

const SliderWrapper = styled.div<{ visible: boolean }>`
    display: ${props => props.visible ? "block" : "none"};
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
`

export default SliderProvider
export { useSliderContext, useSliderStateContext }
